
import { supabase } from "@/integrations/supabase/client";

export const matchService = {
  // Create conversation ID from user IDs (direct messaging - no match required)
  createConversationId(userId1: string, userId2: string): string {
    const sortedIds = [userId1, userId2].sort();
    return `${sortedIds[0]}-${sortedIds[1]}`;
  },

  // Check if users have an existing conversation (optional - for UI purposes)
  async hasExistingConversation(currentUserId: string, targetUserId: string) {
    const { data: existingMessages } = await supabase
      .from('messages')
      .select('id')
      .or(`and(sender_id.eq.${currentUserId},receiver_id.eq.${targetUserId}),and(sender_id.eq.${targetUserId},receiver_id.eq.${currentUserId})`)
      .limit(1);

    return existingMessages && existingMessages.length > 0;
  },

  navigateToChat(conversationId: string) {
    window.location.href = `/messages/${conversationId}`;
  }
};
